import * as actionTypes from '../constants/actionTypes';

export const selectLeagues=(leagues)=>{
    return {
        type:actionTypes.SELECT_LEAGUES,
        leagues:leagues
    }
}

export const setSelectedLeagues=(leagues)=>{
    return dispatch=>{
        dispatch(selectLeagues(leagues));
    }
}